export const Switch = ({ children, value }) => {

  const types = {
      Default: (<Default />).type,
      Case: (<Case />).type
  }

  const typesArray = [types.Default, types.Case];
  const cases = (!Array.isArray(children) ? [children] : children).filter(c => {
    return typesArray.includes(c.type)
  });

  if (!cases.length) {
    return null;
  }

  for (const c of children) {
    if (c.type.name != types.Default && value === c.props.value) {
      return c;
    }
  }

  return cases.find((c) => c.type == types.Default) || null;
};

export const Case = ({ children, value }) => {
  return children;
};

export const Default = ({ children }) => {
  return children;
};
